import { render, staticRenderFns } from "./TableZdmFailures.vue?vue&type=template&id=a1faad46&"
import script from "./TableZdmFailures.vue?vue&type=script&lang=js&"
export * from "./TableZdmFailures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports